import { StyleSheet, Dimensions } from 'react-native'
import {
  heightPercentageToDP as hp,
  widthPercentageToDP as wp,
} from 'react-native-responsive-screen';
import { isWeb, Platform } from '../util/platform';

import AppStyles from '../AppStyles';

const screenWidth = Dimensions.get('window').width;

const webStyles = StyleSheet.create({
  container: {
    flex: 1,
    width: '70%',
    minWidth: screenWidth < 800 ? screenWidth : 800,
    alignSelf: 'center',
    backgroundColor: '#FFF',
    maxHeight: '100vh',
  },
  orangeContainer: {
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
    height: hp(10),
    borderColor: '#FFC451',
    borderWidth: 2,
    borderRadius: 12,
    width: 600,
    maxWidth: wp(85),
    alignSelf: 'center',
    backgroundColor: 'rgba(255, 196, 81, .15)',
    marginBottom: hp(5),
    // Shadow
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 8,
    elevation: 3,
  },
  backgroundImage: {
    position: 'absolute',
    bottom: 0,
    width: isWeb() && screenWidth >= 800 ? 550 : 300,
    height: isWeb() && screenWidth >= 800 ? 370 : 200,
    opacity: 0.5,
    zIndex: -1,
    right: 0,
  },
  backgroundImageTop: {
    position: 'absolute',
    top: 0,
    width: isWeb() && screenWidth >= 800 ? 400 : 320,
    height: isWeb() && screenWidth >= 800 ? 280 : 220,
    opacity: 0.5,
    zIndex: -1,
    left: 0,
  },
  // V3: Clean white card with subtle border
  reportContainer: {
    minHeight: hp(10),
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    marginVertical: isWeb() ? 10 : 6,
    marginHorizontal: 8,
    flexDirection: 'row',
    alignItems: 'center',
    width: 'auto',
    paddingHorizontal: wp(2),
    paddingVertical: isWeb() ? 12 : 14,
    // V3 subtle shadow
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.04,
    shadowRadius: 8,
    elevation: 2,
    borderWidth: 1,
    borderColor: '#E5E5E5',
    // V3: smooth hover transition (web only, ignored on native)
    ...Platform.select({ web: { transitionDuration: '150ms', transitionProperty: 'border-color, box-shadow, background-color' }, default: {} }),
  },
  // V3: hover/focus feedback for clickable report cards (web)
  reportContainerHovered: {
    borderColor: AppStyles.stateSet.focus,
    backgroundColor: AppStyles.stateSet.hover,
    shadowOpacity: 0.1,
    shadowRadius: 12,
  },
  reportContainerPressed: {
    backgroundColor: AppStyles.stateSet.pressed,
    borderColor: AppStyles.stateSet.focus,
  },
  report: {
    flex: 1,
    marginLeft: 1,
    color: 'black',
  },
  reportInfo: {
    width: '100%',
    justifyContent: 'space-between',
    flexDirection: 'row',
  },
  // Narrow (phone-width) cards: wrap the row and pack left so Report #,
  // timestamp, and the status badge flow onto multiple lines instead of
  // colliding with each other / the rows below.
  reportInfoNarrow: {
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    columnGap: 8,
    rowGap: 2,
  },
  reportInfoItem: {
    color: 'black',
  },
  reportInfoContainer: {
    flex: 2,
    padding: 2,
  },
  reportCheck: {
    minWidth: 25,
    justifyContent: 'center',
    alignItems: 'center',
  },
  tagContainer: {
    backgroundColor: 'white',
    flex: 1,
    paddingVertical: hp(1),
    paddingHorizontal: wp(1),
  },
  urgentTag: {
    marginHorizontal: hp(0),
    backgroundColor: 'rgba(239, 68, 68, 0.15)',
    borderWidth: 1,
    borderColor: '#ef4444',
    justifyContent: 'center',
    flexDirection: 'row',
    flex: 1,
    borderRadius: 8,
    minHeight: 28,
    paddingHorizontal: 8,
  },
  closedTag: {
    marginHorizontal: hp(0),
    backgroundColor: 'rgba(34, 197, 94, 0.15)',
    borderWidth: 1,
    borderColor: '#22c55e',
    justifyContent: 'center',
    flexDirection: 'row',
    flex: 1,
    borderRadius: 8,
    minHeight: 28,
    paddingHorizontal: 8,
  },
  TagText: {
    marginHorizontal: wp(1),
    alignSelf: 'center',
  },
  commentsContainer: {
    width: screenWidth >= 800 ? '95%' : '100%',
    alignSelf: 'center',
  },
  commentContainer: {
    marginTop: 20,
  },
  secondaryCommentContainer: {
    textAlign: 'end',
  },
  primaryCommentUserName: {
    fontWeight: 'bold',
  },
  secondaryCommentUserName: {
    fontWeight: 'bold',
    textAlign: 'end',
  },
  primaryCommentDateTime: {
    fontWeight: 'bold',
    color: 'rgba(0, 0, 0, .4)',
  },
  secondaryCommentDateTime: {
    fontWeight: 'bold',
    textAlign: 'end',
    color: 'rgba(0, 0, 0, .4)',
  },
  primaryComment: {
    backgroundColor: 'rgba(255, 196, 81, 0.15)',
    borderLeftWidth: 3,
    borderLeftColor: '#FFC451',
    maxWidth: 500,
    padding: 16,
    borderRadius: 8,
    borderTopLeftRadius: 0,
  },
  secondaryComment: {
    backgroundColor: 'rgba(34, 197, 94, 0.1)',
    borderRightWidth: 3,
    borderRightColor: '#22c55e',
    alignSelf: 'flex-end',
    padding: 16,
    borderRadius: 8,
    borderTopRightRadius: 0,
    maxWidth: 500,
  },
  addComment: {
    width: '100%',
    alignSelf: 'center',
  },
});

export default webStyles;
